import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    token: "",
    LOADING: false,
    networkSuccess: true //是否断网
  },
  // commit调用
  mutations: {
    // 设置token
    setToken(state, token) {
      state.token = token;
    },
    //改变网络状态
    changeNetworkSuccess(state, val) {
      state.networkSuccess = val;
    },
    // showLoading(state) {
    //   state.LOADING = true;
    // },
    // hideLoading(state) {
    //   state.LOADING = false;
    // }
  },
  // dispath调用
  actions: {},
  // 相当于vue的computed属性
  getters: {
    getToken: state => {
      //通过属性访问
      return state.token;
    }
  }
});
// 监听每次调用mutations的时候，都会进入这个方法，借助回调函数可以处理一些自己想做的事情
// store.subscribe((mutations, state) => {
//   localStorage.setItem('cartArray', JSON.stringify(state.cartArray))
// })

export default store;
